import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const onboardingTitle = (props) => {

    const wizardStep = () => {
        const wizardIndex = {
            "info": 1,
            "demo": 2,
            "financials": 3,
        };
        const wizardCurrentStep = wizardIndex[props.tab];
        return (wizardCurrentStep);
    }

    return (
        <div>
        
                <div className="max-w-xl mx-auto">
                    <div>
                        <div className="mx-auto text-center">
                            <div className="modal-title">
                                Complete Account Registration
                            </div>
                            <div className="text-fade">
                                Kindly complete your account registration to continue 
                            </div>
                        </div>
                    </div>

                    <div className="mt-6 mb-2">

                        <div className="wizard-steps wizard-steps-switch-accounts mx-auto">
                            <div className="mx-12 flex">
                                <Link to={(wizardStep() >= 1 ?"/get-started/info/general?preview":"#")} className={(wizardStep() >= 1 ?"active":"cursor-default") + " w-12 h-12 flex-shrink-0 mx-auto relative rounded-full bg-white border border-black flex"}>
                                    <FontAwesomeIcon icon="check" className="hidden label-icon m-auto text-sm font-bold" />
                                    <span className="label-text m-auto text-base">1</span>
                                </Link>
                                <div className="flex-grow">
                                    <div className={(wizardStep() >= 1 ?"bg-ep-primary":"bg-gray-400") + " h-2 mt-5 mx-5 rounded-full"}></div>
                                </div>

                                <Link to={(wizardStep() >= 2 ?"/get-started/info/demo?preview":"#")} className={(wizardStep() >= 2 ?"active":"cursor-default") + " w-12 h-12 flex-shrink-0 mx-auto relative rounded-full bg-white border border-black flex"}>
                                    <FontAwesomeIcon icon="check" className="hidden label-icon m-auto text-sm font-bold" />
                                    <span className="label-text m-auto text-base">2</span>
                                </Link>
                                <div className="flex-grow">
                                    <div className={(wizardStep() >= 2 ?"bg-ep-primary":"bg-gray-400") + " h-2 mt-5 mx-5 rounded-full"}></div>
                                </div>

                                <Link to={(wizardStep() >= 3 ?"/get-started/info/financials?preview":"#")} className={(wizardStep() >= 3 ?"active":"cursor-default") + " w-12 h-12 flex-shrink-0 mx-auto relative rounded-full bg-white border border-black flex"}>
                                    <FontAwesomeIcon icon="check" className="hidden label-icon m-auto text-sm font-bold" />
                                    <span className="label-text m-auto text-base">3</span>
                                </Link>
                            </div>

                            <div className="w-full mt-3 hidden sm:flex text-center text-sm">
                                <Link to={(wizardStep() >= 1 ?"/get-started/info/general?preview":"#")} className={(wizardStep() >= 1 ?"hover:underline":"cursor-default") + " w-36 flex-shrink-0"}>
                                    Company Info
                                </Link>
                                <div className="flex-grow"></div>
                                <Link to={(wizardStep() >= 2 ?"/get-started/info/demo?preview":"#")} className={(wizardStep() >= 2 ?"hover:underline":"cursor-default") + " w-36 flex-shrink-0"}>
                                    Demo
                                </Link>
                                <div className="flex-grow"></div>
                                <Link to={(wizardStep() >= 3 ?"/get-started/info/financials?preview":"#")} className={(wizardStep() >= 3 ?"hover:underline":"cursor-default") + " w-36 flex-shrink-0"}>
                                    Company Financials
                                </Link>
                            </div>
                        </div>


                    </div>
                </div>

        </div>
    )
}

export default onboardingTitle
